import React, { useEffect, useState } from "react";
import { Button, Card, Modal, Spinner, Alert } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { userAigeneratedStories } from "../../../api/aiStoriesServices";
import DataTable from "react-data-table-component";
import { Icon } from "@iconify/react";
import bookimg1 from "../../../assets/img/bookimg1.jpg"; // fallback image

const MEDIA_URL = "https://d3bn54rc14fhr4.cloudfront.net";

export default function AIGeneratedStoriesInfo() {
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(true);
  const [storiesList, setStoriesList] = useState([]);
  const [error, setError] = useState("");
  const [show, setShow] = useState(false);

  const { userId } = useParams();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const fetchAIGeneratedStories = async () => {
    setLoading(true);
    setError("");

    try {
      const response = await userAigeneratedStories({
        userId,
        title: searchText.trim(),
        fullName: searchText.trim(),
        email: searchText.trim(),
      });

      if (response?.data) {
        setStoriesList(response.data);
      } else {
        setError("Failed to retrieve AI generated stories.");
      }
    } catch (err) {
      console.error("Error fetching stories:", err);
      setError("An error occurred while fetching AI generated stories.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userId) {
      fetchAIGeneratedStories();
    }
  }, [userId]);

  const columns = [
    {
      name: "Title",
      minWidth: "250px",
      selector: (row) => row.title,
      sortable: true,
      cell: (row) => (
        <>
          <img
            className="table_img rounded-circle img-thumbnail me-2"
            src={row.thumbnail ? `${row.thumbnail}` : bookimg1}
            alt="thumbnail"
            width={50}
            height={50}
          />
          {row.title}
        </>
      ),
    },
    {
      name: "Characters",
      minWidth: "150px",
      selector: (row) => row.characters?.length || 0,
      sortable: true,
    },
    {
      name: 'Date Created',
      width: '180px',
      selector: row => new Date(row.createdAt).toLocaleDateString(),
      sortable: true,
      cell: (row) => new Date(row.createdAt).toLocaleDateString(),
    },
   
    {
      name: "Actions",
      minWidth: "150px",
      cell: (row) => (
        <>
          <Link className="btnview" to={`/admin/view-story/${row._id}`}>
            <Icon icon="tabler:eye" />
          </Link>
        </>
      ),
    },
  ];

  const filteredData = storiesList.filter((item) => {
    const lowerSearch = searchText.toLowerCase();
    return (
      item.title?.toLowerCase().includes(lowerSearch) ||
      item.user?.fullName?.toLowerCase().includes(lowerSearch) ||
      item.user?.email?.toLowerCase().includes(lowerSearch)
    );
  });

  return (
    <>
      <Card>
        <Card.Body className="bookingtable mt-3">
          <div className="text-end mb-3">
            <input
              type="text"
              placeholder="Search by Title"
              className="searchfield"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") fetchAIGeneratedStories();
              }}
            />
            {/* <Button className="ms-2" onClick={fetchAIGeneratedStories}>
              Search
            </Button> */}
          </div>

          {loading ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ height: "200px" }}
            >
              <Spinner animation="border" variant="primary" />
            </div>
          ) : error ? (
            <Alert variant="danger" className="text-center">
              {error}
            </Alert>
          ) : (
            <DataTable
              columns={columns}
              data={filteredData}
              pagination
              responsive
              className="custom-table"
              noDataComponent={
                <p className="text-center my-4">No stories found</p>
              }
            />
          )}
        </Card.Body>
      </Card>

      <Modal className="modal_Delete" show={show} onHide={handleClose} centered>
        <Modal.Body>
          <div className="modaldelete_div">
            <Icon className="delete_icon" icon="gg:close-o" />
            <h3>Are You Sure?</h3>
            <p>You will not be able to recover the deleted record!</p>
          </div>
          <Button
            onClick={handleClose}
            className="btn btn-primary-outline px-4 me-3"
          >
            Cancel
          </Button>
          <Button
            onClick={handleClose}
            className="btn btn-primary px-4 min_width110"
          >
            Ok
          </Button>
        </Modal.Body>
      </Modal>
    </>
  );
}
